import { useEffect, useState } from 'react';

import variables from 'src/styles/_commonVariables.module.scss';

export const useTextLengthLimit = (clientWidth: number) => {
  const [textLengthLimit, setTextLengthLimit] = useState<number>(95);

  useEffect(() => {
    if (clientWidth <= Number(variables.psychicListDesktopWidthPointQuery)) {
      setTextLengthLimit(75);
    } else {
      setTextLengthLimit(95);
    }
  }, [clientWidth]);

  return textLengthLimit;
};
